import { Vendor, SingleResponse, VendorResourceUpdateRequest, SearchParams, VendorLedger } from 'common';
import { SharedApiService, mockVendorApplication, mockVendorResponse } from '@ng-shared';
import { Observable, map, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class OptometristService extends SharedApiService {

    constructor(http: HttpClient) {
        super(http);
    }

    //#region GETS and Searches (Retrieval)

    /**
     * TODO: this might not be needed.
     * This would only be the case if the user wants to see the patients of the application.
     * 
     * @param applicationId application to list patients for.
     * @returns 
     */
    public listCustomerProductPatients(applicationId: number): Observable<any> {
        if (this.useMocks) {
            return this.mockRequest<any>(mockVendorApplication);
        } else {
            return this.http.get(`${this.baseUrl}/customerProductPatient/list/${applicationId}`, this.authHeaders);
        }
    }

    // /**
    //  * API for:
    //  * - Pre-Approved Applications
    //  * - Active Applications
    //  * - Cancelled or Declined Applications
    //  * - Closed Applications
    //  * - Legal, Deceased, or Administration Applications
    //  * 
    //  * Api by:
    //  * - Optometrist Zone
    //  */
    // public searchCustomerProduct(params: SearchParams): Observable<ApiResponse<CustomerApplicationProduct[]>> {
    //     // customerProduct/search
    //     // To find the patients of the  
    //     // Use on /customerProductPatient/list/{applicationId}
    //     if (this.useMocks) {
    //         return this.mockRequest(mockVendorApplication);
    //     } else {
    //         // return this.http.post<ApiResponse<CustomerApplicationProduct[]>>(`${this.baseUrl}/customerProduct/getSearch`, params, this.authHeaders)
    //         return this.http.post<ApiResponse<CustomerApplicationProduct[]>>(`${this.baseUrl}/customerProduct/vendorSearch`, params, this.authHeaders)
    //             .pipe(map(response => {
    //                 // Response "result" is a string that needs to be parsed.
    //                 response.result = JSON.parse(response.result as any);
    //                 return response;
    //             }));
    //     }
    // }

    /**
     * Performs a search on the server and then returns the FIRST vendor with the provided ID.
     * @param vendorId The ID of the vendor to search for.
     * @returns The vendor with the provided ID.
     */
    public searchFindVendor(vendorId: number): Observable<Vendor | undefined> {
        if (this.useMocks) return this.mockRequest<SingleResponse<string>>({
            result: JSON.stringify(mockVendorResponse),
            total: 1,
        })
            .pipe(map((vendors) => {
                const parsed = JSON.parse(vendors.result) as Vendor[];
                return (parsed || []).find(v => v.id === vendorId)
            }));
        else {
            return this.http.post<SingleResponse<string>>(`${this.baseUrl}/vendor/search`, { id: vendorId }, this.authHeaders)
                .pipe(map(response => {
                    try {
                        const parsed = JSON.parse(response.result) as Vendor[];
                        return (parsed || []).find(v => v.id === vendorId)
                    } catch (error) {
                        console.error('error:', error, response);
                        throw error;
                    }
                }));
        }
    }

    /**
     * Search for vendor ledgers.
     *
     * @param {SearchParams} params Search parameters.
     * @return {Observable<SingleResponse<VendorLedger[]>>} List of vendor ledgers.
     */
    public searchVendorLedger(params: SearchParams): Observable<SingleResponse<VendorLedger[]>> {
        if (this.useMocks) {
            return this.mockRequest<SingleResponse<VendorLedger[]>>({ result: [], total: 0 });
        } else {
            return this.http.post<SingleResponse<VendorLedger[]>>(`${this.baseUrl}/vendorLedger/search`, params, this.authHeaders)
                .pipe(map(response => {
                    // Response "result" is a string that needs to be parsed.
                    response.result = JSON.parse(response.result as any);
                    return response;
                }));
        }
    }

    //#endregion
    //#region POSTS (Mutations)

    public cancelApplication(applicationId: number) {
        if (this.useMocks) return this.mockObs();
        else {
            return this.http.get(`${this.baseUrl}/vendorApplication/cancel/${applicationId}`, this.authHeaders);
        }
    }

    /**
     * [id] // ResourceVendorId if updating.
     * [vendorId] // vendor id
     * [resourceId] // new resource id?
     * [resourceType] // 15 for signature
     * @param body 
     * @returns 
     */
    public vendorResourceSave(body: VendorResourceUpdateRequest): Observable<any> {
        if (this.useMocks) return this.mockObs();
        else {
            return this.http.post(`${this.baseUrl}/vendorResource/save`, { ...body }, this.authHeaders);
        }
    }

    //#endregion

    public earlyPaymentRequest(paymentDate: string): Observable<any> {
        if (this.useMocks) return this.mockObs();
        else {
            // return this.http.post(`${this.baseUrl}/vendorLedger/earlyPaymentRequest`, { paymentDate }, this.authHeaders);
            return throwError(() => new Error('Not supported yet.'));
        }
    }

}